import React from "react";
import { Link } from "react-router-dom";
import DocumentTitle from "react-document-title";

/**
 * Shown for any path that is not a category or an article.
 *
 * Before this existed an unknown article slug crashed the whole app into a
 * blank page (the old Question route read `data.meta.title` off `undefined`),
 * which is what the "Aku punya Voucher Diskon Pre-Order" card on the home page
 * did for months after its file was renumbered.
 */
const NotFound = () => (
  <DocumentTitle title="Halaman tidak ditemukan - Kyou Help Center">
    <div className="hc-container hc-notfound">
      <p className="hc-eyebrow">Help Center</p>
      <h1 className="hc-notfound__title">Halaman ini tidak ditemukan</h1>
      <p className="hc-notfound__text">
        Mungkin tautannya sudah berubah, atau artikelnya sudah dipindah. Coba cari lewat halaman utama Help Center ya.
      </p>
      <Link to="/" className="hc-btn">Ke halaman utama Help Center</Link>
    </div>
  </DocumentTitle>
);

export default NotFound;
